import { useChartColors } from './useChartColors';

/**
 * Hook to provide consistent tooltip styling for charts
 * Returns standardized tooltip props using theme-aware colors
 */
export const useChartTooltip = () => {
  const chartColors = useChartColors();

  return {
    contentStyle: {
      backgroundColor: chartColors.tooltip.background,
      border: `1px solid ${chartColors.tooltip.border}`,
      borderRadius: '8px',
      color: chartColors.tooltip.text,
    },
    labelStyle: {
      color: chartColors.tooltip.text,
    },
    itemStyle: {
      color: chartColors.tooltip.text,
    },
  };
};
